import { t } from "i18next";
import { z } from "zod";

import { MappedStakeholder, StakeholderRoleEnum } from "src/core/constants/folder";
import { documentsUploadSchema } from "src/core/forms/folder/documentsUpload.schema";
import { dateOfBirthRule, nameRule } from "src/core/forms/validators/rules";

export const updateStakeholderFullSchema = () =>
  z.object({
    title: z.string().optional(),
    firstName: nameRule(t, { checkIfShown: true, required: true }),
    birthName: nameRule(t, { checkIfShown: true }),
    lastName: nameRule(t, { checkIfShown: true, required: true }),
    roles: z
      .array(z.nativeEnum(StakeholderRoleEnum))
      .min(1, { message: t("global.form.error.mandatoryField") })
      .optional(),
    citizenshipCountryCode: z.string().optional(),
    birthDate: dateOfBirthRule(t, { checkIfShown: true, required: true }),
    residenceCountryCode: z.string().optional(),
    birthCountryCode: z.string().optional(),
    birthPlace: z.string().optional(),
    documents: documentsUploadSchema(t),
  });
export type UpdateStakeholderFullFormValues = z.infer<
  ReturnType<typeof updateStakeholderFullSchema>
>;

export const defaultUpdateStakeholderFullValues = (
  selectedStakeholderForEdit: MappedStakeholder
): UpdateStakeholderFullFormValues => {
  return {
    title: selectedStakeholderForEdit.title ?? "",
    firstName: selectedStakeholderForEdit.firstName ?? "",
    birthName: selectedStakeholderForEdit.birthName ?? "",
    lastName: selectedStakeholderForEdit.lastName ?? "",
    roles: selectedStakeholderForEdit.roles ?? [],
    citizenshipCountryCode: selectedStakeholderForEdit.citizenshipCountryCode ?? "",
    birthDate: selectedStakeholderForEdit.birthDate ?? "",
    residenceCountryCode: selectedStakeholderForEdit.residenceCountryCode ?? "",
    birthCountryCode: selectedStakeholderForEdit.birthCountryCode ?? "",
    birthPlace: selectedStakeholderForEdit.birthPlace ?? "",
    documents: {},
  };
};
